<template>
  <div v-if="appointment">
    <v-card
      color="primary"
      tile
    >
      <v-container class="pa-0">
        <v-toolbar
          v-for="row in tabsRowsCnt"
          :key="row"
          :height="tabsRowHeight"
          color="primary"
          class="zero-padding-toolbar"
          flat
        >
          <v-toolbar-items
            class="container zero-padding-toolbar inspection-tabs"
          >
            <v-btn
              v-for="item in tabsInRowItems(row)"
              :key="item.name"
              :to="{ name: item.name }"
              :color="tabBtnClass(
                item,
                tabIsFilled(item.name))"
              active-class="primary--text active-tab"
              block
              depressed
              class="ma-0 tab-btn"
              style="border-radius: 0"
            >
              <div :id="isConfirmSelfIns(item.name)">{{ item.title }}</div>
              <v-icon
                v-if="tabIsFilled(item.name)"
                dark
                color="white"
                class="filled-badge"
                size="10">done</v-icon>
              <span
                v-else
                class="filled-badge amber--text">
                {{ remainingFields[item.name] }}
              </span>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
      </v-container>
    </v-card>
    <v-container fluid>
      <v-btn
        :color="left(tabId).length ? 'info darken-2' : 'primary darken-2'"
        class="left-indicator"
        fab
        small
        style="top: 10px"
        @click="scrollToFirstRemaining"
      >
        {{ left(tabId).length ? left(tabId).length : 'OK' }}
      </v-btn>
      <v-slide-y-transition mode="out-in">
        <v-layout
          row
          wrap
          class="mx-0 mt-3"
          justify-center
        >
          <arrived-dialog
            v-if="!appointment.meetingTookPlace && summary"
            :appointment="summary"
          />
          <inspection-dialog
            v-if="displayInspectionDialog"
            :curr-step="currentAiInspectionStep"
          />
          <shuppinhyo-dialog
            v-if="!!appointment.selfInspectionFlag"
          />
          <finished-dialog />
          <v-progress-circular
            v-if="loading"
            id="loading"
            :width="5"
            color="primary"
            size="100"
            indeterminate
          />
          <div
            v-else-if="!dataLoaded"
            class="text-xs-center"
          >
            <v-icon
              size="100px"
              color="red lighten-5"
            >lock</v-icon>
          </div>
          <v-container v-else>
            <v-fade-transition mode="out-in">
              <div
                :key="tabId"
              >
                <v-alert
                  :value="showUnfilled"
                  outline
                  color="red lighten-1"
                  class="mb-5">
                  <ul class="px-5">
                    <div class="title mb-3">未入力の必須項目</div>
                    <li
                      v-for="(item, i) in left(tabId)"
                      :key="item + i"
                      style="cursor: pointer"
                      @click="scrollToItem(item)"
                    >
                      {{ labels[snakeToCamel(item)] || snakeToCamel(item) }}
                    </li>
                  </ul>
                </v-alert>
                <router-view
                  :appointment-id="appointmentId"
                />
              </div>
            </v-fade-transition>
          </v-container>
        </v-layout>
      </v-slide-y-transition>
    </v-container>
  </div>
</template>

<style lang="scss" scoped>
@import '../styles/main';

.hidden {
  display: none;
}

.darker {
  background-color: #424242 !important;
  color: white !important;
}

.lighter {
  background-color: #FFFFFF !important;
}

.filled-badge {
  position: absolute;
  top: 10px;
  right: 15px;
  padding: 2px;
  font-size: 10px;
  width: 10px;
  height: 10px;
  text-align: center;
  vertical-align: center;

  @include phone-this {
    top: 2;
    right: 6;
  }
}

.active-tab .filled-badge {
  color: #D32F2F !important;
}

.tab-btn {
  @include phone-this {
    font-size: 12px;
  }
}

#is-confirm-self-ins {
  @include phone-this {
    position: relative;
    right: 0.5em;
    font-size: 11px;
  }
}

.left-indicator {
  position: -webkit-sticky;
  position: sticky;
  left: 40px;
  z-index: 50;
  width: 20px;
  height: 20px;
  font-size: 10px;
}

.zero-padding-toolbar {
  margin: 0;
  padding: 0;
}
</style>

<style lang="scss">
.inspection-tabs {
  .tab-btn {
    .v-btn__content {
      position: static;
    }
  }
}
</style>

<script>
import ArrivedDialog from '../components/ArrivedDialog';
import FinishedDialog from '../components/FinishedDialog';
import ShuppinhyoDialog from '../components/ShuppinhyoDialog';
import InspectionDialog from '../components/InspectionDialog';

import AttentionTab from './tabs/AttentionTab';
import OwnerTab from './tabs/OwnerTab';
import BasicTab from './tabs/BasicTab';
import EquipmentTab from './tabs/EquipmentTab';
import PhotosTab from './tabs/PhotosTab';
import EvaluationTab from './tabs/EvaluationTab';
import SalesPointsTab from './tabs/SalesPointsTab';
import DamageSchemeTab from './tabs/DamageSchemeTab';
import RepairsSchemeTab from './tabs/RepairsSchemeTab';
import ConfirmForSelfInsTab from './tabs/ConfirmForSelfInsTab';
import tabs from '../tabs';
import { labels, aiInspectionStatuses, aiInspectionErrorCodes } from '../options';
import { GET_REMAINING_FIELDS, PRE_INSPECTION_FLAGS, APPOINTMENT_AND_OWNER_SUMMARY, GET_AI_INSPECTION_STATUS, GET_AI_PHOTOS } from '../queries';

export function snakeToCamel(s) {
  return s.includes('_') ? s.toLowerCase().replace(/(_\w)/g, m => m[1].toUpperCase()) : s;
}

export const defaultRemainingFields = {
  basic: 0,
  // separate object to store state for photos counter
  basicPhotos: 0,
  owner: 0,
  equipment: 0,
  'sales-points': 0,
  photos: 0,
  photosPhotos: 0,
  attention: 0,
  damages: 0,
  repairs: 0,
  evaluation: 0,
  'confirm-for-self-ins': 0,
};

export default {
  components: {
    ArrivedDialog,
    FinishedDialog,
    ShuppinhyoDialog,
    AttentionTab,
    BasicTab,
    EquipmentTab,
    OwnerTab,
    PhotosTab,
    EvaluationTab,
    SalesPointsTab,
    DamageSchemeTab,
    RepairsSchemeTab,
    ConfirmForSelfInsTab,
    InspectionDialog,
  },
  apollo: {
    getAiInspectionStatus: {
      query: GET_AI_INSPECTION_STATUS,
      pollInterval: 3000,
      skip() {
        return this.skipPolling;
      },
      fetchPolicy: 'network-only',
      variables() {
        return {
          appointmentId: this.appointmentId,
        };
      },
      result({ data }) {
        const { appointment } = data;
        if (this.redirected &&
        appointment.aiInspectionStatus === aiInspectionStatuses.AWAITING_REDIRECTION) {
          this.$store.commit('setAiInspectionStatus', {
            apollo: this.$apollo,
            appId: this.appointmentId,
            status: aiInspectionStatuses.REDIRECTED,
          });
        }
        if (appointment.aiInspectionExpired &&
          appointment.aiInspectionStatus === aiInspectionStatuses.REDIRECTED) {
          this.updateStatusAndErrorCode(
            aiInspectionStatuses.INSPECTION_FAILED,
            aiInspectionErrorCodes.INSPECTION_TIME_LIMIT,
          );
        }
      },
      update({ appointment }) {
        this.checkPolling(appointment);

        this.updateStatusAndErrorCode(
          appointment.aiInspectionStatus,
          appointment.aiInspectionErrorCode,
        );

        this.$apollo.queries.getAiPhotos.refetch();
      },
    },
    getAiPhotos: {
      query: GET_AI_PHOTOS,
      fetchPolicy: 'network-only',
      variables() {
        return {
          appointmentId: this.appointmentId,
        };
      },
      result({ data }) {
        if (!data || !data.getAiPhotos || data.getAiPhotos.data.length === 0) {
          this.$store.commit('setAiPhotos', []);
          this.$store.commit('setPhotoSelectionButton', false);
          return;
        }

        data.getAiPhotos.data.forEach((d) => {
          if (typeof d.partId === 'object') return;
          const pasedIds = !d.partId ? [] : JSON.parse(d.partId);
          this.$set(d, 'partId', pasedIds);
        });

        this.$store.commit('setAiPhotos', data.getAiPhotos.data);
        if (data.getAiPhotos.data.length > 0) {
          this.$store.commit('setPhotoSelectionButton', true);
        }
        this.refreshRemainingFields();
      },
    },
    remainingFields: {
      query: GET_REMAINING_FIELDS,
      fetchPolicy: 'network-only',
      variables() {
        return {
          appointmentId: this.appointmentId,
          tabs: [
            'Owner',
            'Basic',
            'Equipment',
            'SalesPoints',
            'Photos',
            'Damages',
            'Attention',
            'Repairs',
            'ConfirmForSelfIns',
            'Evaluation',
          ],
        };
      },
      skip() {
        return !this.appointment;
      },
      update({ remainingFields }) {
        this.loaded = true;

        this.remainingFieldsLabels = remainingFields
          .reduce((acc, cur) => ({
            ...acc,
            [cur.tab.replace(/[A-Z0-9]/g, a => `-${a.toLowerCase()}`).replace(/^-/, '')]: cur.fields,
          }), {});

        const output = {
          ...defaultRemainingFields,
          ...remainingFields.reduce((acc, cur) => ({
            ...acc,
            [cur.tab.replace(/[A-Z0-9]/g, a => `-${a.toLowerCase()}`).replace(/^-/, '')]: cur.count,
          }), {}),
        };

        if (!parseInt(this.appointment.selfInspectionFlag, 10)) {
          delete output['confirm-for-self-ins'];
        }
        return output;
      },
    },
    appointment: {
      query: PRE_INSPECTION_FLAGS,
      fetchPolicy: 'network-only',
      variables() {
        return {
          id: this.appointmentId,
        };
      },
      result({ data }) {
        const { selfInspectionFlag } = data.appointment;
        const confirmForSelfIns = tabs.find(s => s.name === 'confirm-for-self-ins');
        confirmForSelfIns.hidden = !parseInt(selfInspectionFlag, 10);
      },
    },
    summary: {
      query: APPOINTMENT_AND_OWNER_SUMMARY,
      fetchPolicy: 'network-only',
      variables() {
        return {
          id: this.appointmentId,
        };
      },
      update: data => data.appointment,
    },
  },
  data() {
    return {
      loading: false,
      dataLoaded: true,
      initialLoad: true,
      remainingFields: defaultRemainingFields,
      remainingFieldsLabels: {},
      labels,
      skipPolling: false,
    };
  },
  metaInfo: {
    title: '案件',
  },
  computed: {
    appointmentId() {
      return parseInt(this.$route.params.id, 10) || 0;
    },
    tabId() {
      return this.$route.name;
    },
    tabs() {
      return tabs.filter(tab => !tab.hidden);
    },
    tabsInRow() {
      return this.breakpoint.sm || this.breakpoint.xs ? 3 : this.tabs.length;
    },
    tabsRowsCnt() {
      return Math.floor(this.tabs.length / this.tabsInRow);
    },
    tabsRowHeight() {
      return this.tabsRowsCnt > 1 ? '44px' : null;
    },
    clientArrived() {
      return this.$store.state.appointment.client_arrived;
    },
    title() {
      return this.$route.name;
    },
    showUnfilled() {
      const { tabId, left } = this;
      return tabId !== 'damages' && tabId !== 'evaluation'
        && left(tabId) && left(tabId).length > 0;
    },
    redirected() {
      return this.$route.query.status === 'waiting';
    },
    aiInspectionStatus() {
      return this.$store.state.aiInspectionStatus;
    },
    currentAiInspectionStep() {
      const statusStepMapping = {
        [aiInspectionStatuses.INSPECTION_STARTED]: 1,
        [aiInspectionStatuses.AWAITING_REDIRECTION]: this.redirected ? 2 : 0,
        [aiInspectionStatuses.REDIRECTED]: this.redirected ? 2 : 0,
        [aiInspectionStatuses.INSPECTION_PROCESS]: this.redirected ? 2 : 0,
        [aiInspectionStatuses.INSPECTION_SUCCESS]: 3,
        [aiInspectionStatuses.INSPECTION_FAILED]: 4,
        [aiInspectionStatuses.INSPECTION_POSTPONED]: 5,
      };

      return statusStepMapping[this.aiInspectionStatus] || 0;
    },
    displayInspectionDialog() {
      return this.currentAiInspectionStep > 0 && this.$store.state.isMobile;
    },
  },
  watch: {
    $route(newVal, oldVal) {
      if (oldVal.params.id) {
        this.initialLoad = false;
      }

      // if dialog is opening, close it
      if (this.$store.state.showPhotoSelectionDialog) {
        this.$store.commit('togglePhotoSelectionDialog');
      }
    },
  },
  mounted() {
    if (this.$route.name === 'inspection') {
      this.$router.replace({
        name: this.tabs[0].name,
      });
    }

    window.addEventListener('car.add_photo', this.onAddPhotoEvent);
  },
  methods: {
    snakeToCamel,
    scrollToItem(item) {
      this.scrollTo(document.querySelector(`[data-label-scroll="${item}"]`));
    },
    scrollToFirstRemaining() {
      this.scrollToItem(this.left(this.tabId)[0]);
    },
    isConfirmSelfIns(name) {
      return name === 'confirm-for-self-ins' ? 'is-confirm-self-ins' : null;
    },
    tabBtnClass({ name }, filled) {
      if (!filled) {
        return name === this.$route.name
          ? 'lighter'
          : 'darker';
      }

      return name === this.$route.name
        ? 'lighter'
        : 'primary';
    },
    tabsInRowItems(row) {
      if (this.tabsRowsCnt === 1) return this.tabs;

      const items = [];
      const count = parseInt(this.appointment.selfInspectionFlag, 10) && row === 3 ? 4 : 3;

      for (let i = 0; i < count; i += 1) {
        const tabId = ((row - 1) * this.tabsInRow) + (i);
        items.push(this.tabs[tabId]);
      }

      return items;
    },
    setError({ status }) {
      this.$store.commit('setError', status);
      this.loading = false;
    },
    setValues(response) {
      const data = response.data_array;
      if (!data) {
        this.setError(response);
        return;
      }

      this.$store.commit('setAppointment', data);
      this.$store.commit('setCarId', data.car_id);

      this.loading = false;
      this.dataLoaded = true;
    },
    tabIsFilled(name) {
      return this.remainingFields[name] === 0;
    },
    left(tab) {
      return this.remainingFieldsLabels[tab] ? this.remainingFieldsLabels[tab] : {};
    },
    onAddPhotoEvent({ photo }) {
      const appointment = this.$store.state.appointment;

      if (!appointment) {
        return;
      }

      let index = -1;
      let type = 'photo_container';

      if (!photo.name) {
        type = 'additional_photos';
        index = appointment.additional_photos.findIndex(
          item => item.id === photo.old_id,
        );
      } else {
        index = appointment.photo_container.findIndex(
          item => item.name === photo.name,
        );
      }

      if (index >= 0) {
        appointment[type].splice(index, 1, photo);
      } else {
        appointment[type].push(photo);
      }
    },
    checkPolling(appointment) {
      if (![aiInspectionStatuses.AWAITING_REDIRECTION,
        aiInspectionStatuses.REDIRECTED,
        aiInspectionStatuses.INSPECTION_PROCESS].includes(appointment.aiInspectionStatus)) {
        this.skipPolling = true;
      }
    },
    updateStatusAndErrorCode(status, errorCode) {
      this.$store.commit('setAiInspectionErrorCode', {
        apollo: this.$apollo,
        appId: this.appointmentId,
        errorCode,
      });

      this.$store.commit('setAiInspectionStatus', {
        apollo: this.$apollo,
        appId: this.appointmentId,
        status,
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/InspectionPage.vue